import { CustomButton, CustomInputSelect, CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import { IProfileFormMeta } from '@Modules/home/containers/forms/ProfileFormHandler/ProfileFormMeta';
import {
  Box,
  Button,
  Divider,
  Flex,
  Stack,
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

type Props = {
  onSubmit: any,
  meta: IProfileFormMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};
export const ProfileFormUI = ({ onSubmit, meta, isLoading, isSubmitting }: Props) => {

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
      <Box onSubmit={handleSubmit(onSubmit)} as="form" bg='chakra-body-bg' boxShadow="sm" borderRadius="lg">
        <Stack spacing="5" px={{ base: '4', md: '6' }} py={{ base: '5', md: '6' }}>
          <Stack spacing="6" direction={{ base: 'column', md: 'row' }}>
            <CustomFormControl isInvalid={!!errors[meta.firstName.name]} label={meta.firstName.label}>
              <CustomTextInput
                meta={meta.firstName}
                register={register(meta.firstName.name)}
                hasError={errors[meta.firstName.name]}
              />
            </CustomFormControl>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.lastName.name]} label={meta.lastName.label}>
              <CustomTextInput
                meta={meta.lastName}
                register={register(meta.lastName.name)}
                hasError={errors[meta.lastName.name]}
              />
            </CustomFormControl>
          </Stack>
          <Stack spacing="6" direction={{ base: 'column', md: 'row' }}>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.gender.name]} label={meta.gender.label}>
              <CustomInputSelect
                meta={meta.gender}
                register={register(meta.gender.name)}
                hasError={errors[meta.gender.name]}
              />
            </CustomFormControl>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.function.name]} label={meta.function.label}>
              <CustomTextInput
                meta={meta.function}
                register={register(meta.function.name)}
                hasError={errors[meta.function.name]}
              />
            </CustomFormControl>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.dateOfBirth.name]} label={meta.dateOfBirth.label}>
              <CustomInput
                meta={meta.dateOfBirth}
                register={register(meta.dateOfBirth.name)}
                hasError={errors[meta.dateOfBirth.name]}
              />
            </CustomFormControl>
          </Stack>
          <Stack spacing="6" direction={{ base: 'column', md: 'row' }}>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.placeOfBirth.name]} label={meta.placeOfBirth.label}>
              <CustomTextInput
                meta={meta.placeOfBirth}
                register={register(meta.placeOfBirth.name)}
                hasError={errors[meta.placeOfBirth.name]}
              />
            </CustomFormControl>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.email.name]} label={meta.email.label}>
              <CustomTextInput
                meta={meta.email}
                register={register(meta.email.name)}
                hasError={errors[meta.email.name]}
              />
            </CustomFormControl>
            <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.username.name]} label={meta.username.label}>
              <CustomTextInput
                meta={meta.username}
                register={register(meta.username.name)}
                hasError={errors[meta.username.name]}
              />
            </CustomFormControl>
          </Stack>
        </Stack>
        <Divider />
        <Flex direction="row-reverse" py="4" px={{ base: '4', md: '6' }}>
          <CustomButton loading={isSubmitting} type="submit" colorScheme="blue">
            Sauvegarder
          </CustomButton>
        </Flex>
      </Box>
  )
}